import { routing } from '@/app'
import React from 'react'
import { useGetBreakpoint } from '@/lib/SFrame'
import { DesktopNavbar, MobileNavBar } from './variants'

export const Navbar = () => {
    const breakpoint = useGetBreakpoint()
    return <React.Fragment>{breakpoint === 'mobile' ? <MobileNavBar /> : <DesktopNavbar />}</React.Fragment>
}
